import Axios from 'axios'
import config from '@/config/config.js'

// const baseUrl = '/b99/ESick/api/'
// const getKeyUrl = baseUrl + 'MedicalCertificate/GetKey?idType=15&idnum=51716835'
// const getMedicalCerificate = baseUrl + 'MedicalCertificate/Get'
// const baseUrl = '/b2/personal-service/publicServant/api/medicalCertificate/'
const baseUrl = config.apiDomain.ALI + '/ext/ps/mc/'
// const dafBaseUrl = '/b2/personal-service/publicServant/api/'
const getInfoFromSSMUrl = baseUrl + 'getInfoFromSSM'
// const LOCAL_OR_UAT = process.env.VUE_APP_SERVER_ENV === 'LOCAL' || process.env.VUE_APP_SERVER_ENV === 'UAT'
// const getInfoFromSSMUrl = LOCAL_OR_UAT ? baseUrl + 'fake/fakeGetInfoFromSSM' : baseUrl + 'getInfoFromSSM'
const findInfoBystaffCodeUrl = baseUrl + 'findMCInfoByEuid'

// Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
Axios.defaults.headers.timeout = 8000

export default {

  getInfoFromSSM (cb) {
    Axios.get(getInfoFromSSMUrl).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  findInfoBystaffCode (cb) {
    Axios.get(findInfoBystaffCodeUrl).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  submitToDaf (data, cb) {
    const url = baseUrl + 'submitToDaf'
    // const url = LOCAL_OR_UAT ? baseUrl + 'fake/fakeSubmitToDaf' : baseUrl + 'submitToDaf'
    Axios.post(url, data).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  findSubmitToDafMCInfoByKeyNo (keyNo, cb) {
    Axios.get(baseUrl + 'findSubmitToDafMCInfoByKeyNo' + '?keyNo=' + keyNo).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  findMCNotifyInfoByKeyNo (keyNo, dfInflowId, dfInfowIdSupport, cb) {
    let query = ''
    if (dfInfowIdSupport) {
      query = '&dfInfowIdSupport=' + dfInfowIdSupport
    }
    Axios.get(baseUrl + 'findMCNotifyInfoByKeyNo' + '?keyNo=' + keyNo + '&dfInflowId=' + dfInflowId + query).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  findLastNotifyInfo (cb) {
    Axios.get(baseUrl + 'findLastNotifyInfo').then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  findMcReceiverInfo (keyNo, mcInfoId, cb) {
    Axios.get(baseUrl + 'findMcReceiverInfo?keyNo=' + keyNo + '&mcInfoId=' + mcInfoId).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  dlSignedPdfFromOSS (cb, keyNo, mcInfoId) {
    return new Promise((resolve, reject) => {
      Axios.get(baseUrl + 'dlSignedPdfFromOSS?keyNo=' + keyNo + '&mcInfoId' + mcInfoId, {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(
        response => {
          cb(response.data)
          resolve()
        },
        error => {
          console.error(error)
        }
      )
    })
  },

  dlSignedPdfFromSSM (cb, keyNo) {
    return new Promise((resolve, reject) => {
      Axios.get(baseUrl + 'dlSignedPdfFromOSS?keyNo=' + keyNo, {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(
        response => {
          cb(response.data)
          resolve()
        },
        error => {
          console.error(error)
        }
      )
    })
  },

  getSupportEntity (cb) {
    Axios.get(baseUrl + 'getSupportEntity').then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  checkSSMStatusAndDLSigned (cb, keyNo, mcInfoId) {
    Axios.get(baseUrl + 'checkSSMStatusAndDLSigned?keyNo=' + keyNo + '&mcInfoId=' + mcInfoId).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  downloadMCPDF (cb, isDownloadUnsigned, keyNo, mcInfoId) {
    Axios.get(baseUrl + 'downloadMCPDF?isDownloadUnsigned=' + isDownloadUnsigned + '&keyNo=' + keyNo + '&mcInfoId=' + mcInfoId, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  downloadSignedPdfFromOSS (cb, keyNo, mcInfoId) {
    console.log('downloadSignedPdfFromOSS, ' + keyNo + ',' + mcInfoId)
    Axios.get(baseUrl + 'dlSignedPdfFromOSS?keyNo=' + keyNo + '&mcInfoId=' + mcInfoId, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  downloadSignedPdfFromSSM (cb, keyNo) {
    Axios.get(baseUrl + 'dlSignedPdfFromSSM?keyNo=' + keyNo, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  }

  // getKey (cb) {
  //   Axios.get(getKeyUrl).then(
  //     response => {
  //       cb(response)
  //     },
  //     error => {
  //       console.log(error)
  //     }
  //   )
  // },

  // getMedicalCerificate (cb) {
  //   Axios.get(getMedicalCerificate, {
  //     auth: {
  //       user: 'Safp',
  //       password: 'QiS+fywxKy0ZZ+C2wPq48CV4ognp7RRq6/T2vbwM0dk='
  //     }
  //   }).then(
  //     response => {
  //       cb(response)
  //     },
  //     error => {
  //       console.log(error)
  //     }
  //   )
  // }

}
